(function () {
  // --- Instant Add-to-Cart feedback ----------------------------------------
  // On TeeInBlue products the SDK renders + uploads the personalised artwork on
  // click, freezing the button for ~2-3s before its loader appears. We show a
  // spinner the instant the press starts so the button never looks frozen, and
  // we block repeat clicks during that dead zone.
  //
  // Two button types exist depending on the product:
  //   * theme button  -> button[name="add"] (.t4s-btn-loading__svg) — has a
  //                      native spinner we reuse so it matches the button colour.
  //   * TeeInBlue button -> #teeAtcButton — no native spinner, we use an overlay.
  var ATC_SELECTOR = 'button[name="add"], #teeAtcButton';
  var SAFETY_MS = 12000; // never leave the button stuck if nothing cleans up

  var busyButton = null;
  var clickAllowed = true;
  var resetTimer = null;

  function armReset() {
    clearTimeout(resetTimer);
    resetTimer = setTimeout(resetLoader, SAFETY_MS);
  }

  function isNativeButton(btn) {
    return btn.classList.contains('t4s-btn-loading__svg') && btn.querySelector('.t4s-loading__spinner');
  }

  function revealNativeSpinner(btn, show) {
    var sp = btn.querySelector('.t4s-loading__spinner');
    if (!sp) return;
    var svg = sp.querySelector('.t4s-svg-spinner');
    if (show) {
      sp.removeAttribute('hidden');
      if (svg) svg.removeAttribute('hidden');
    } else {
      sp.setAttribute('hidden', '');
      if (svg) svg.setAttribute('hidden', '');
    }
  }

  function showLoader(btn) {
    if (!btn || busyButton) return;
    busyButton = btn;

    if (isNativeButton(btn)) {
      // Reuse the theme's own spinner. We deliberately use our own class instead
      // of the theme's `is--loading`, because that sets pointer-events:none which
      // would stop the very first click from reaching TeeInBlue. Repeat clicks
      // are blocked in JS below instead.
      revealNativeSpinner(btn, true);
    } else if (!btn.querySelector('.tib-preloader')) {
      var pre = document.createElement('span');
      pre.className = 'tib-preloader';
      pre.setAttribute('aria-hidden', 'true');
      btn.appendChild(pre);
    }

    btn.classList.add('is--tib-preloading');
    armReset();
  }

  function resetLoader() {
    clearTimeout(resetTimer);
    resetTimer = null;
    clickAllowed = true;
    var btn = busyButton;
    busyButton = null;
    if (!btn) return;
    btn.classList.remove('is--tib-preloading');
    revealNativeSpinner(btn, false);
  }

  function atcFrom(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    var btn = t.closest(ATC_SELECTOR);
    if (!btn) return null;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return null;
    return btn;
  }

  // Instant feedback the moment the press starts — fires before the click, so the
  // spinner paints before the SDK's synchronous render blocks the thread.
  // Delegated on document so it survives the theme re-rendering the button.
  document.addEventListener('pointerdown', function (e) {
    var btn = atcFrom(e);
    if (btn) showLoader(btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = atcFrom(e);
    if (btn) showLoader(btn);
  });

  // Block repeat clicks during the dead zone. Capture phase on document runs
  // before TeeInBlue's own handler: the first click passes, extras are swallowed.
  document.addEventListener(
    'click',
    function (e) {
      if (!atcFrom(e)) return;
      // Never interfere with the app's own programmatic clicks — TeeInBlue
      // re-triggers the add to finalise it after the artwork uploads, and those
      // are isTrusted:false. We only ever block genuine repeat user clicks.
      if (!e.isTrusted) return;
      if (clickAllowed) {
        clickAllowed = false; // let the genuine first click through
        armReset(); // ensure the guard always clears even if pointerdown didn't fire
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
    },
    true
  );

  // Best-effort early cleanup when the add finishes (harmless if these never fire).
  ['teeinblue-event-cart-added', 'cart:added', 'product:added', 'ajaxProduct:added', 'cart:refresh'].forEach(
    function (ev) {
      document.addEventListener(ev, resetLoader);
    }
  );

  // --- Existing behaviour: shake the ATC button + clean up fade slides --------
  document.addEventListener('teeinblue-event-component-injected', function () {
    var teeCartButton = document.getElementById('teeAtcButton');

    function addAnimationClass() {
      teeCartButton.classList.add('is--animated');
      teeCartButton.classList.add('t4s-ani-shake');
      setTimeout(function () {
        teeCartButton.classList.remove('is--animated');
        teeCartButton.classList.remove('t4s-ani-shake');
      }, 2000);
    }

    if (teeCartButton) {
      setInterval(addAnimationClass, 6000);
    }

    Array.from(document.querySelectorAll('.t4s-slide-eff-fade')).forEach(function (e) {
      return e && e.remove && e.remove();
    });
  });
})();
